module.exports = __webpack_public_path__ + "img/Hongkong-2.16cac49b.jpg";